<template>
  <DdpSummaryCard
    v-if="isDynamic"
    :program="program"
    :earnings="earnings"
    :basis="basis"
    :is-dollar-budget="isDollarBudget"
    :button-color="buttonColor"
    :button-text-color="buttonTextColor"
    :preview="preview"
    :draft="draft"
    :stacked="stacked"
    @open-program="$emit('open-program', $event)"
  />
  <LegacySummaryCard
    v-else
    :program="program"
    :earnings="earnings"
    :basis="basis"
    :is-dollar-budget="isDollarBudget"
    :button-color="buttonColor"
    :button-text-color="buttonTextColor"
    :preview="preview"
    :draft="draft"
    :stacked="stacked"
    @open-program="$emit('open-program', $event)"
  />
</template>

<script>
import DdpSummaryCard from "./DdpSummaryCard.vue";
import LegacySummaryCard from "./LegacySummaryCard.vue";
import { isDynamicIncentive } from "@/utils/isDynamicIncentive";

export default {
  name: "ProgramSummaryCard",
  components: { DdpSummaryCard, LegacySummaryCard },
  emits: ["open-program"],
  props: {
    program: {
      type: Object,
      required: true,
    },
    earnings: {
      type: [String, Number],
      default: null,
    },
    basis: {
      type: String,
      default: null,
    },
    isDollarBudget: {
      type: Boolean,
      default: null,
    },
    buttonColor: {
      type: String,
      default: null,
    },
    buttonTextColor: {
      type: String,
      default: null,
    },
    preview: {
      type: Boolean,
      default: false,
    },
    draft: {
      type: Boolean,
      default: false,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isDynamic() {
      return isDynamicIncentive(this.program);
    },
  },
};
</script>
